module.exports = __webpack_public_path__ + "static/media/shield-common.02032ce4.png";